export default __webpack_public_path__ + "static/media/bgImg.f5fe8f38.png";